import React, { FC, ReactNode } from 'react';
import { Grid, GridSpacing, Hidden } from '@material-ui/core';

import { columnSplitToGridSizes } from 'helpers';

interface Props {
  left: ReactNode;
  right: ReactNode;
  header?: ReactNode;
  headerSpacing?: GridSpacing;
  mainSpacing?: GridSpacing;
  desktopSplit?: string;
}

const AppMain2Column: FC<Props> = props => {
  const { desktopSplit, header, headerSpacing, mainSpacing, left, right } = props;
  const [desktopLeft, desktopRight] = columnSplitToGridSizes(desktopSplit);
  const spacing = header ? headerSpacing : 0;

  return (
    <Grid container direction="column" spacing={spacing}>
      {header && (
        <Grid item xs>
          {header}
        </Grid>
      )}
      <Grid item xs>
        <Grid container spacing={mainSpacing}>
          <Grid item xs lg={desktopLeft}>
            {left}
          </Grid>
          <Hidden mdDown>
            <Grid item xs lg={desktopRight}>
              {right}
            </Grid>
          </Hidden>
        </Grid>
      </Grid>
    </Grid>
  );
};

AppMain2Column.defaultProps = {
  desktopSplit: '9/3',
  header: null,
  headerSpacing: 3,
  mainSpacing: 3,
};

export default AppMain2Column;
